module.exports = __webpack_public_path__ + "img/left_video4.fa3bf5e9.png";